module.exports = __webpack_public_path__ + "img/MollyRapture.617a4c77.jpg";